import { makeLazy } from "lib/make-lazy"
import { bind } from "lib/@components/binding/bind"

const PictureListEditor = makeLazy(
    () => import("lib/@components/document-viewer/picture-list-editor-load"),
    "PictureListEditor"
)
export const BoundPictureListEditor = bind(<PictureListEditor />, { extract: (v) => v, default: {} })
